module.exports = __webpack_public_path__ + "img/icon-player.f26ab061.svg";